import React, { useEffect } from "react";
import WavyDivider from "./WavyDivider";
import { Gift, Heart, Sparkles } from "lucide-react";

const PUBLISHABLE_KEY =
  "pk_test_51TWzMIKGRE8ye4ZiINQMDfOleFUXz6GNP0gtEP8qsQ3PFjfkhNHPSjeSpdkW78VwhdbfhEZ5cVLCMrx7Q1hEBwcs00OEN3A6cX";

const CARDS = [
  {
    id: "buy_btn_1TX0QKKGRE8ye4ZigT9xx4Ba",
    eyebrow: "Carte Découverte",
    title: "Soin Découverte",
    subtitle: "30 min",
    icon: Sparkles,
  },
  {
    id: "buy_btn_1TX0RmKGRE8ye4Zik66zk4Aw",
    eyebrow: "Carte Bien-Être",
    title: "Soin Complet",
    subtitle: "1 h 15",
    icon: Heart,
    featured: true,
  },
  {
    id: "buy_btn_1TX00EKGRE8ye4ZiKGdgD9w5",
    eyebrow: "Carte Privilège",
    title: "Forfait 5 séances",
    subtitle: "5 × 1 h 15",
    icon: Gift,
  },
];

const CartesCadeaux = () => {
  return (
    <section id="cartes-cadeaux" className="section cartes-cadeaux">
      <div className="section-header cc-header">
        <WavyDivider />
        <h2 className="section-title">(S')Offrir un moment de bien-être</h2>
        <p className="cc-intro">
          Envie d'offrir une parenthèse de bien-être à vos proches ?<br />
          Pensez aux Cartes Cadeaux — valables 6 mois.
        </p>
      </div>

      <div className="cc-grid">
        {CARDS.map(({ id, eyebrow, title, subtitle, icon: Icon, featured }) => (
          <article key={id} className={`cc-card ${featured ? "is-featured" : ""}`}>
            {featured && <span className="cc-ribbon">Le plus offert</span>}
            <div className="cc-card-top">
              <span className="cc-icon">
                <Icon size={20} strokeWidth={1.4} />
              </span>
              <p className="cc-eyebrow">{eyebrow}</p>
              <h3 className="cc-title">{title}</h3>
              <p className="cc-subtitle">{subtitle}</p>
            </div>
            <div className="cc-buy">
              <stripe-buy-button
                buy-button-id={id}
                publishable-key={PUBLISHABLE_KEY}
              />
            </div>
          </article>
        ))}
      </div>

      <p className="cc-note">
        Paiement sécurisé par Stripe · Carte cadeau envoyée par email après achat
      </p>
    </section>
  );
};

export default CartesCadeaux;
